import { Box } from '@mui/material';

import { Typography } from '@occc/ui-design-system';

export const DisconnectedStoresTooltip = () => (
  <Box>
    <Typography variant='body2' sx={{ mb: 1 }}>
      Offline stores impact your overall metrics. To bring them back online, follow these steps:
    </Typography>
    <Box component='ul' sx={{ pl: 3, m: 0 }}>
      <li>Power cycle the POS terminal (shut down fully, then restart)</li>
      <li>Verify the store’s internet connection is stable</li>
      <li>Confirm the POS is processing transactions normally</li>
      <li>Ensure the POS software is up to date</li>
      <li>Contact your POS support team if the issue continues</li>
    </Box>
  </Box>
);
